<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="回收计划名称">
                <el-input v-model="formInline.activeName" placeholder="输入回收计划名称查询"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryDataList">查询</el-button>
                <el-button type="success" @click="addActive()">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="activeList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="40"></el-table-column>
            <el-table-column prop="activeNo" label="活动号" width="150"></el-table-column>
            <el-table-column prop="bindCode" label="bindCode" width="150"></el-table-column>
            <el-table-column prop="activeName" label="回收计划名称" width="170"></el-table-column>
            <el-table-column prop="beginTime" label="开始时间" width="150">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.beginTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" width="150">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.endTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="editeActive(scope.row)">编辑</el-button>
                    <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
                    <el-button type="primary" size="mini" @click="handlePage(scope.row)">跳转连接配置</el-button>
                    <el-button type="success" size="mini" @click="configProperty(scope.row)">活动文案配置</el-button>
                    <el-button type="primary" size="mini" @click="shareDataConfig(scope.row)">分享配置</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="活动配置" :visible.sync="showDialog">
            <el-form :model="active" :rules="rules" label-width="120px">
                <el-form-item label="活动号" v-show="false">
                    <el-input v-model="active.activeNo" placeholder="活动号"></el-input>
                </el-form-item>
                <el-form-item label="bindCode" v-show="false">
                    <el-input v-model="active.bindCode" placeholder="bindCode"></el-input>
                </el-form-item>
                <el-form-item label="活动名称" prop="activeName">
                    <el-input v-model="active.activeName" placeholder="活动名称"></el-input>
                    <span style="color: red">*必填 不允许重复</span>
                </el-form-item>
                <el-form-item label="默认关键字" prop="keywordId">
                    <el-select v-model="active.keywordId" clearable filterable placeholder="请选择默认关键字">
                        <el-option
                                v-for="item in keywordList"
                                :key="item.id"
                                :label="item.keyword"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动邀请人数" prop="inviteNum">
                    <el-input-number v-model="active.inviteNum" :min="0" :max="100"
                                     placeholder="活动邀请最大人数"></el-input-number>
                    <span style="color: red">*必填</span>
                </el-form-item>

                <el-form-item label="开始时间" prop="beginTime">
                    <el-date-picker
                            v-model="active.beginTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择活动开始时间">
                    </el-date-picker>
                    <span style="color: red">*必选</span>
                </el-form-item>

                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker
                            v-model="active.endTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择活动结束时间">
                    </el-date-picker>
                    <span style="color: red">*必选</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveActiveConfig('active')">保 存</el-button>
                    <el-button @click="reset('active')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="活动文案配置" :visible.sync="showPropertyDialog">
            <el-form :model="reuionActivePropertyList" label-width="120px">
                <el-form-item>
                    <div style="color: red">
                        文案配置<br/>
                        1、日期配置------ 例如 订阅期开始:2021-03-04 订阅期结束:2021-03-07, 预约期开始2021-03-07 预约期开始2021-03-20, 活动期开始2021-03-20 活动期结束2021-03-28 前一个结束日期和后一个开始日期必须连续   <br/>
                        2、日期配置------ 活动开始时间和结束时间需要包含上面的日期配置<br/>
                        3、兑换阶梯配置------ 例如 {"name":"变声口罩","num":5},{"name":"百变汽球","num":10} 如添加一行15人数 在行尾填写   <span style="color: #0086b3">,{"name":"魅力口红","num":15} </span>  <br/>
                        4、根据活动实际情况，修改示例文案<br/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-table :data="reuionActivePropertyList" stripe border center :size="GCONFIG.styleTableSize"
                              v-loading="loading" width="180">
                        <el-table-column type="index" label="序号" width="60">
                        </el-table-column>
                        <el-table-column prop="propertyKey" width="220" label="文案标题">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.propertyKey disable="true" clearable placeholder="用于区分是干嘛的"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="propertyValue" label="文案内容">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.propertyValue clearable placeholder="文案内容"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="propertyRemark" label="文案说明">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.propertyRemark clearable placeholder="文案说明"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="110" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="primary" v-show="isEdit" size="mini" @click="saveActiveProperty(scope.row)">保存
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="saveActivePropertyList()">批量保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="页面配置" :visible.sync="showPageDialog">
            <el-form :model="pageConfig" :rules="rules" label-width="120px">
                <el-form-item label="连接地址" prop="activeUrl">
                    <el-input v-model="pageConfig.activeUrl" placeholder="连接地址 例如:http://wx.lechun.cc"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="showPageDialog = false">取 消</el-button>
                    <el-button type="primary" @click="savePageConfig()" class="header-btn">
                        保 存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveList,
        getKeywordsOption,
        saveReunionActiveProperty,
        saveActive,
        getActivePropertyList,
        saveActivePropertyApi,
        saveActivePageApi,
        getActivePageApi,
        saveActivePropertyListApi
    } from '../../api/api';
    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        data() {
            return {
                formInline: {
                    activeNo: "",
                    activeName: "",
                    activeType: 30,
                    status: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                bindCode: '',
                showDialog: false,
                showPropertyDialog: false,
                loading: true,
                isEdit:false,
                showPageDialog:false,
                pageConfig: {
                    activePageId: '',
                    activeNo: '',
                    activeSummary: '',
                    /*跳转连接*/
                    activeUrl: '',
                    /*平台标示*/
                    color1: '',
                    color2: '',
                    /*是否会员*/
                    isvip: 0,
                    /*会员权益*/
                    vipRightType: '0',
                    activeContent: ''
                },
                reuionActivePropertyList: [
//                    {
//                        propertyName: 'subscribeStartTime',
//                        propertyValue: '2021-03-04',
//                        propertyRemark: '',
//                        propertyId: '',
//                        propertyKey: '订阅开始时间',
//                        status:1,
//                        bindCode: ''
//                    },
//                    {
//                        propertyName: 'subscribeEndTime',
//                        propertyValue: '2021-03-07',
//                        propertyRemark: '可订阅活动开放通知',
//                        propertyId: '',
//                        propertyKey: '订阅结束时间',
//                        status:1,
//                        bindCode: ''
//                    },
                    {
                        propertyName: 'planStartTime',
                        propertyValue: '2021-03-07',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '计划开始时间',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'planEndTime',
                        propertyValue: '2021-03-20',
                        propertyRemark: '可预约活动计划',
                        propertyId: '',
                        propertyKey: '计划结束时间',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'exchangeStartTime',
                        propertyValue: '2021-03-20',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '兑换开始时间',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'exchangeEndTime',
                        propertyValue: '2021-03-28',
                        propertyRemark: '乐纯的伙伴们线下见面啦',
                        propertyId: '',
                        propertyKey: '兑换结束时间',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'activeNotice',
                        propertyValue: '线下未设置回收小岛的伙伴，分享本次回收行动积攒CARE种子，累计到下地一场回收行动兑换更多小岛特产。',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '活动须知',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'activeTitle',
                        propertyValue: '有趣有爱节活动须知',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '活动文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'recoveryDesc',
                        propertyValue: '确认爱心值 ',
                        propertyRemark: '填入你手中的空瓶数，了解你当前的愛心值',
                        propertyId: '',
                        propertyKey: '回收文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'exchangeDesc',
                        propertyValue: '选择兑换物资 ',
                        propertyRemark: '根据当前拥有的爱心值，选择要获得的物资',
                        propertyId: '',
                        propertyKey: '兑换文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'inviteDesc',
                        propertyValue: '分享给和你一样喜欢宠物的朋友，邀请她和你一样去有趣有爱节吧。每成功邀请1位好友参与有趣有爱节,可获得2个爱心彩蛋。',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '邀请页文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'period',
                        propertyValue: '第一期',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '期次',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'siteName',
                        propertyValue: '流浪宠物站点地址',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '站点名称文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'exchangeScoreDesc',
                        propertyValue: '{"name":"变声口罩","num":5},{"name":"百变汽球","num":10}',
                        propertyRemark: '',
                        propertyId: '',
                        propertyKey: '兑换阶梯文案',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: 'sharePrice',
                        propertyValue: '2',
                        propertyRemark: '每邀请一个用户获得多少爱心值',
                        propertyId: '',
                        propertyKey: '邀请用户奖励爱心值',
                        status:1,
                        bindCode: ''
                    },
                    {
                        propertyName: '推文连接',
                        propertyValue: 'https://mp.weixin.qq.com/s/15GJYdJyfww5wfducDcpDw',
                        propertyRemark: '查看特产',
                        propertyId: '',
                        propertyKey: 'articleUrl',
                        status:1,
                        bindCode: ''
                    }
                ],
                active: {
                    activeNo: '',
                    activeName: '',
                    tjType: 1,
                    deptId: 9,
                    status: 1,
                    beginTime: '',
                    endTime: '',
                    createTime: '',
                    payamount: 0,
                    bindCode: '',
                    activeType: 30,
                    cityId: 0,
                    keywordId: 0,
                    payKeywordId: 0,
                    vipRightType: '',
                    platformId: 4,
                    platformGroupId: 1000,
                    inviteNum: 10,
                    joinNum: 0,
                    categoryId: ''
                },
                keywordList: [],//关键字列表
                //活动统计列表
                activeList: [],// 活动列表
                loading: true,
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.queryDataList();
            this.getEnableKeyworldList();
        },
        methods: {
            queryDataList(){
                this.loading = true;
                getActiveList(this.formInline).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.activeList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            configProperty(data){
                this.showPropertyDialog = true;
                this.loading = true;
                getActivePropertyList({bindCode: data.bindCode}).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        if (res.data.value.total > 0) {
                            this.reuionActivePropertyList = res.data.value.list;
                            this.isEdit=true;
                        } else {
                            this.isEdit=false;
                            let len = this.reuionActivePropertyList.length
                            for (var i = 0; i < len; i++) {
                                this.reuionActivePropertyList[i].bindCode = data.bindCode;
                            }
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.activeNo,
                    query: {picType: '15', picName: row.activeName, picState: 'product'}
                })
            },
            //查询
            queryList(){
                this.queryDataList();
                this.formInline.currentPage = 1
            },
            addActive(){
                //添加活动
                this.active.activeNo = '';
                this.showDialog = true;
                this.active = {
                    activeNo: '',
                    activeName: '',
                    tjType: 1,
                    deptId: 9,
                    status: 1,
                    beginTime: '',
                    endTime: '',
                    createTime: '',
                    payamount: 0,
                    bindCode: '',
                    activeType: 30,
                    cityId: 0,
                    keywordId: 0,
                    payKeywordId: 0,
                    vipRightType: '',
                    platformId: 4,
                    platformGroupId: 1000,
                    inviteNum: 0,
                    joinNum: 0
                };
            },
            editeActive(row){
                this.showDialog = true;
                this.active.activeNo = row.activeNo;
                this.active.bindCode = row.bindCode;
                this.active.activeName = row.activeName;
                this.active.tjType = row.tjType;
                this.active.deptId = row.deptId;
                this.active.status = row.status;
                this.active.beginTime = row.beginTime;
                this.active.endTime = row.endTime;
                this.active.payamount = row.payamount;
                this.active.activeType = row.activeType;
                this.active.cityId = row.cityId;
                this.active.keywordId = row.keywordId;
                this.active.payKeywordId = row.payKeywordId;
                this.active.vipRightType = row.vipRightType;
                this.active.platformId = row.platformId;
                this.active.platformGroupId = row.platformGroupId;
                this.active.inviteNum = row.inviteNum;
                this.active.joinNum = row.joinNum;
            },
            saveActiveConfig(){
                this.loading = true;
                saveActive(this.active).then((res) => {
                    this.loading = false;
                    this.showDialog = false;
                    if (res.data.status == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.queryList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveActiveProperty(data){
                this.loading = true;
                saveActivePropertyApi(data).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
//                        this.showPropertyDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveActivePropertyList(){
                this.loading = true;
                saveActivePropertyListApi({itemList: encodeURIComponent(JSON.stringify(this.reuionActivePropertyList))}).then((res) => {
                    this.loading = false;
                    this.showPropertyDialog = false;
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        //this.queryList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handlePage(row){
                this.pageConfig= {
                    activePageId: '',
                    activeNo: row.activeNo,
                    activeSummary: '',
                    activeUrl: '',
                    color1: '',
                    color2: '',
                    isvip: 0,
                    vipRightType: '0',
                    activeContent: ''
                }
                this.showPageDialog=true;
                this.getActivePage();
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId: 1}).then((res) => {
                    this.keywordList = res.data.filter(item => (item.type == 'text' || item.type == 'coupon' || item.type == 'news'));
                    this.keywordList.push({'id': 0, 'keyword': '无'});
                });
            },
            shareDataConfig(row){
                this.$router.push({
                    path:  '/activeQrMangement',
                    query: {activeNo:row.activeNo,activeName:row.activeName+'配置分享',activeType:row.activeType}
                });
            },
            getActivePage() {
                this.loading = true;
                this.pageConfig.activeUrl='';
                getActivePageApi({activeNo: this.pageConfig.activeNo}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        if (res.data.value != null){
                            this.pageConfig = res.data.value;
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            savePageConfig(){
                if(this.pageConfig.activeUrl==''){
                    this.$message({
                        showClose: true,
                        message: 'url必填',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveActivePageApi(this.pageConfig).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showPageDialog=false;
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryDataList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryDataList();
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            }
        }
    }
</script>
<style scoped>
    .customer-id {
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/reunion/ReunionActive.vue